module.exports = {
  login:{
    zw:'တရုတ်',
    mw:'မြန်မာ',
    en:'အဂ်လိပ်',
    name:'အကောင့် ID',
    pws:'လျှို့ဝှက်နံပါတ်',
    submit:'အကောင့်ဝင်မည်',
    msg:'အချက်လက်ပြည်စုံအောင်ဖြည့်ပါ',
    amount:'฿',
    remember:'မှတ်ထားမည်'
  },
  navs:{
    phone:'ဖုန်း',
    tel:'ဖုန်း',
    betNum:' ကြိမ်နှုန်းလိုသည်'
  },
  home:{
    maintain:'ပြုပြင်ဆဲ',
    login:'လော့ဂ်အင်အရင်ဝင်ပါ',
    await:'စောင့်ဆိုင်းပေးပါ',
    customer:'လျှိဝှက်နံပါတ်ပြောင်းရန်အေးဂျင့်ထံဆက်သွယ်ပါ',
    account:'ငွေသွင်း/ငွေထုတ်',
    message:'မက်ဆေ့',
    per:'မန်ဘာအချက်အလတ်',
    record:'ဂိမ်းမှတ်တမ်း',
    paw:"လျှိုဝှက်နံပါတ်ပြန်ပြင်မည်",
    exit:'လော့ဂ်အောက်',
    signIn:'လောဂ်အင်',
    more:'နောက်ထပ်',
    hot:'အဆော့များသော',
    live:'LIVE ဖဲ',
    game:'Jackpot',
    new:'ဂိမ်းအသစ်',
    slot:'စလော့ဂိမ်း',
    fish:'ငါးဂိမ်း',
    rng:'အခြားဂိမ်း',
    index:'ပင်မ',
    app:'APPဒေါင်းရန်',
    t_1:'ရက်စွဲ/အမည်',
    t_2:'jackpot အနိုင်ရ'

  },
  message:{
    title:'သတင်း',
    per:'ကိုယ်ရေးအချက်အလက်',
    system:'ကြေငြာချက်',
    data:'မက်ဆေ့ချ်ကို ရွေးမထားပါ',
    close:'CLOSE'
  },
  user:{
    title:'မန်ဘာအချက်အလက်'
  },
  account:{
    title:'ငွေသွင်း/ငွေထုတ်',
    upper:"ငွေသွင်း",
    lower:"ငွေထုတ်",
    noData:'လက်ရှိဘာအချက်လက်မှမရှိသေးပါ',
    sn:'လုပ်ငန်းစဉ်နံပါတ်',
    abbr:'ဂိမ်းအမျိုးအစား',
    point:'အမှတ်',
    rate:'လဲလှယ်နှုန်း',
    type:'အမျိုးအစား',
    time:'အချိန်',
    homePage:"ပထမစာမျက်နှာ",
    lastPage:"နောက်ဆုံစာမျက်နှာ",
    total:'စုစု‌ပေါင်း',
    info:'မက်ဆေ့',
    page:'စာမျက်နှာ',
    beforeAccount:'ငွေမသွင်းမှီ လက်ကျန်',
    afterAccount:'ငွေသွင်းပြီး လက်ကျန်',
    amount:'ပမာဏ',
  },
  record:{
    title:"ကြိမ်နှုန်းမှတ်တမ်း",
    no:'လုပ်ငန်းစဉ်နံပါတ်',
    amount:'လောင်းကြေး',
    profit:'အမြတ်',
    time:'အချန်',
    status:'အနေအထား',
    unsettled:'မရှင်းသေး',
    win:'နိုင်',
    lose:'ရှုံး',
    sum:'သရေ',
    ping:'ဂိမ်းအမျိုးအစား',
    operate:'လုပ်ဆောင်သည်',
    submit:'မြင်ပါ',
    submitTitle:'စီးပွားရေး အသေးစိတ်များ'
  },
  download:{
    title:'ဒေါင်းလုဒ်',
    domain:"JY076",
    name:'jy99',
    app:"ေဆာ့၀ဲလ်ဒေါင်းလုဒ်",
    num:'4.9',
    score:'၅၉၈၅ ရမှတ်',
    edition:'# 1',
    style:'ဂိမ်းေဆာ့၀ဲ',
    new:'နောက်ဆုံးထွက်ဗားရှင်',
    time:'2022-03-04 1.63(4.7MB)',
    security:'အဆင့်မြင့်လုံခြုံရေး',
    speed:'မြန်မြန်ဖွင့်',
    remember:"URL ကို မှတ်ထားရန် မလိုအပ်ပါ။",
  },
  loginPaw:{
    title:'အကောင့်ဝင်စကားဝှက်ကို ပြောင်းပါ',
    t_2:'စကားဝှက်ဟောင်း',
    t_3:'စကားဝှက်အသစ်',
    t_4:'စကားဝှက်ကို အတည်ပြုပါ',
    t_5:'စကားဝှက်ဟောင်းကို ထည့်ပါ',
    t_6:'စကားဝှက်အသစ်တစ်ခု ထည့်ပါ',
    t_7:'ကျေးဇူးပြု၍ စကားဝှက်ကို ထပ်မံထည့်ပါ',
    t_8:'အတည်ပြုပါ',
    t_9:'ငွေပေးချေမှု စကားဝှက်ကို ပြောင်းပါ',
    t_10:'ငွေပေးချေမှု စကားဝှက်ကို ပြန်လည်သတ်မှတ်ပါ',
    t_11:'လျှိဝှက်နံပါတ် ပြောင်းရန် ',
    t_12:'ငွေပေးချေမှု စကားဝှက်ကို သတ်မှတ်ပါ',
    t_13:'စကားဝှက်',
    t_14:'စကားဝှက်ကို ထည့်ပါ',
    t_15:'အချက်အလက် အပြည့်အစုံ ဖြည့်ပါ',
    t_16:'စကားဝှက်နှစ်ခု ကွဲလွဲနေသည်',
    t_17:'စကားဝှက်ကို ပြုပြင်ပြီးပြီ',
    t_18:'စကားဝှက် သတ်မှတ်ပြီးပြီ'
  },
  customer:{
    title:'ဝန်ဆောင်မှု',
    tip:'ချစ်လှစွာသော အသုံးပြုသူများ ၊ သင်သည် ဝက်ဆိုက်နှင့်ပတ်သက်သည့်ပြသာနာများကို ငွေသွင်းရန် သိုမဟုတ် ဂိမ်းလင့် လိုအပ်ပါက ၊ သင့်အား ၂၄ နာရီပတ်လုံး ဝန်ဆောင်မှုပေးနိုင်ရန် ကျွမ်းကျင်သော ဝန်ဆောင်မှုကို ကျေးဇူးပြု၍ အောက်တွင်နှိပ်ပြီးဆက်သွယ်လိုက်ပါရှင့်',
    copy:'ကူယူခြင်း',
    qrCode:'Qr ကုဒ်',
    close:'ပိတ်သည်'
  },
  messenger:{
    title:"24နာရီ၀န်ဆောင်မှု",
    copy:'ကော်ပီနံပါတ်',
    success:'ကော်ပီအောင်မြင်သည်',
    err:'ကော်ပီကူးခြင်းမအောင်မြင်ပါ',
  },
  Online:{
    title:'ဝန်ဆောင်မှု',
    send:'ပို့မည်။',
    drop:'ဒေါင်းလုပ်ဆွဲမည်။',
    face:'QQ အီမ',
    tip:'ဆက်သွယ်ရန်ကိုရွေးချယ်ပါ။',
    del:'မှတ်တမ်းကို ရှင်းလင်းထားသည်။',
    test:'ပေးပိုရန် အကြောင်းအရာကို ထည့်ပါ။',
  },
  thalIndex:{
    t_1:'ဝင်ရန်',
    t_2:'WINNERS',
    t_3:'2D/3D',
    t_4:'မှတ်တမ်း',
    t_5:'2Dထိုးမည်',
    t_6:'3Dထိုးမည်',
    t_7:'2D',
    t_8:'3D',
    t_9:'Section',
    t_10:'UPDATED',
    t_11:'Closing Time',
    t_12:'AM',
    t_13:'PM',
    t_14:'ထိုးမည်',
    t_15:"Internet",
    t_16:'SET:',
    t_17:'VALUE:',
    t_18:'Live',
    t_19:'Modern',
    t_20:'Internet',
    t_21:'ပွဲကို ရွေးချယ်ပါ',
    t_22:"ကစားပွဲမရှိသေးပါ"
  },
  ranking:{
    t_1:'Winners',
  },
  bet2D:{
    t_1:' ထိုးမည်',
    t_2:'Close Time：',
    t_3:'Luck Number',
    t_4:'အမြန်နံပါတ်ရွေးပါ',
    t_5:'မှတ်စု အရေအတွက်：',
    t_6:'စုစုပေါင်း ပမာဏ：',
    t_7:'စုစုပေါင်း ပမာဏ',
    t_8:'အမြန်ရွေးချယ်ပါ',
    t_9:'Box',
    t_10:'ကြီး',
    t_11:'ငယ်',
    t_12:'မ',
    t_13:'စုံ',
    t_14:'စုံစုံ',
    t_15:'စုံ မ',
    t_16:'မစုံ',
    t_17:'မ မ',
    t_18:'အပူး',
    t_19:'1 whole',
    t_20:'the top',
    t_21:'Later',
    t_22:'Star',
    t_23:'Star R',
    t_24:'Power',
    t_25:'Power R',
    t_26:'20 each'
  },
  bet3D:{
    t_1:' ထိုးမည်',
    t_2:'နံပါတ်',
    t_3:"ဆ",
    t_4:'ဖျက်ရန်',
    t_5:'ပမာဏ',
    t_6:'အတည်ပြုနံပါတ်',
    t_7:'လောင်းကြေးပမာဏကို ဖြည့်ပါ',
    t_8:'အောင်မြင်သည်',
    t_9:'နံပါတ်ဖြည့်ရန်  ဥပမာ- 000',
    t_10:'ဤနံပါတ်အား ထိုးတဲ့သူများသည်',
    t_11:'လောင်းကြေးပမာဏကိုဖြည့်ပါ',
    t_12:'Lucky နံပတ်：',
    t_13:'ဤနံပါတ်အား ထိုးခွင့်မရှိတော့ပါ：',
    t_14:'အကြောင်းရာ',
    t_15:'နံပါတ်ကို ရွေးပါ'
  },
  recordsBet:{
    t_1:'လောင်းကြေး မှတ်တမ်း',
    t_2:'မှတ်တမ်းများ',
    t_3:'NO.',
    t_4:'လောင်းကြေးပမာဏ',
    t_5:'ဝင်ငွေ',
    t_6:'နာမည်',
    t_7:'20231030233000',
    t_8:'နံပါတ်',
    t_9:'ပမာဏ',
    t_10:'ပြန်အမ်းေငွ',
    t_11:'ဆ',
    t_12:'ရက်စွဲ',
    t_13:'ဆ',


  },
  playerRankRecord:{
    t_1:'Order details'
  }

}




// WEBPACK FOOTER //
// ./src/assets/i18n/my.js